import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { OptionRaw } from 'webapp/components/form/select';
import FormSelectWithActionComponent from 'webapp/components/form/select-with-action';

// we use this only on frontend to represent the company value
// we use this only on frontend to represent the company value

import type { Goal, Group } from 'webapp/models-custom';

export const FakeCompanyId = '-987651234'; // we use this only on frontend to represent the company value

interface GoalInlineGroupComponentArgs {
	model: Goal;
	canEdit?: boolean;
	saveOnChange?: boolean;
	isDisabled?: boolean;
}

export default class GoalInlineGroupComponent extends Component<GoalInlineGroupComponentArgs> {
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('account') declare accountService: Service.Account;
	@service('model-manager/groups') declare mmGroupsService: Service.ModelManager.Groups;

	get model() {
		return this.args.model;
	}

	get accountCompany() {
		return this.accountService.company || 'Company';
	}

	get groupId() {
		return this.model.groupId ?? FakeCompanyId;
	}

	@cached
	get groupOptions(): OptionRaw<string>[] {
		const options: OptionRaw<string>[] = [];

		options.push({
			value: FakeCompanyId,
			label: this.accountService.company || 'Company',
			group: 'Company',
		});

		this.mmGroupsService.groupModels.forEach((group) => {
			options.push({
				value: group.id!,
				label: group.name,
				group: 'Groups',
			});
		});

		return options;
	}

	get groupActions() {
		return [
			{
				id: null,
				text: 'New group',
				isSpecial: true,
				position: 'bottom',
				onClick: () => {
					this.mmGroupsService.openCreatePopup((group: Group) => {
						this.changeGroup(group.id!);
					});
				},
				html: '<a role="button" class="invite"><ui-icon name="Plus" size="sm"></ui-icon> New group</a>',
			},
		];
	}

	@action
	changeGroup(groupId: string) {
		let newGroupId = null;
		if (groupId && groupId !== FakeCompanyId) {
			newGroupId = groupId;
		}

		if (this.model.groupId !== newGroupId) {
			this.model.groupId = newGroupId;

			if (this.args.saveOnChange) {
				void this.model.save();
			}
		}
	}
	<template>
		{{#if @canEdit}}
			<FormSelectWithActionComponent
				name="groupId"
				@selected={{this.groupId}}
				@options={{this.groupOptions}}
				@actionOptions={{this.groupActions}}
				@onChange={{this.changeGroup}}
				@placeholder="Select group"
				@showFloatlabel={{false}}
				@isRequired={{true}}
				@isNumeric={{false}}
				@isDisabled={{@isDisabled}}
			/>
		{{else}}
			<div class="panel-avatar company">
				<CommonUiIconComponent @name="Company" @size="sm" />
			</div>

			<span>{{this.accountCompany}}</span>
		{{/if}}
	</template>
}
